import EmblaCarousel from "embla-carousel";

(() => {
	const imagesCarousels = document.querySelectorAll(".m46");
	const options = {
		loop: true,
		draggable: true,
		align: "start",
	};

	function slideWidths(slides) {
		let slideWidth = 0;
		slides.forEach((slide) => {
			const slideStyle = slide.currentStyle || window.getComputedStyle(slide);
			slideWidth = slideWidth + slide.clientWidth + parseInt(slideStyle.marginLeft, 10) * 2;
		});
		return slideWidth;
	}

	const checkWidth = (carousel, embla, slides, autoplayer) => {
		if (slideWidths(slides) / 1.3 < window.innerWidth) {
			carousel.classList.add("is-static");
			autoplayer.stop();
		} else {
			autoplayer.play();
			carousel.classList.remove("is-static");
		}
		embla.reInit();
	};

	imagesCarousels.forEach((carousel) => {
		const container = carousel.querySelector(".m46__container");
		for (var i = container.children.length; i >= 0; i--) {
			container.appendChild(container.children[(Math.random() * i) | 0]);
		}

		const slides = carousel.querySelectorAll(".m46__slide");
		const viewport = carousel.querySelector(".m46__wrapper");
		const embla = EmblaCarousel(viewport, options);

		embla.on("init", () => {
			checkWidth(carousel, embla, slides, autoplayer);
		});

		embla.on("resize", () => {
			checkWidth(carousel, embla, slides, autoplayer);
		});
	});
})();
